const Loading = () => {
  return (
    <div className='default-button loading-notifier'>LOADING</div>
  )
}

export default Loading